import ls from 'localstorage-slim';
export default {
  showTherapistPicture(state) {
    return (
      state.showTherapistPicture ||
      ls.get('showTherapistPicture', { decrypt: true }) ||
      null
    );
  },
  showTherapistPsychologyOrganizationLink(state) {
    return (
      state.showTherapistPsychologyOrganizationLink ||
      ls.get('showTherapistPsychologyOrganizationLink', { decrypt: true }) ||
      null
    );
  },
  showOtherAbilityFilter(state) {
    return (
      state.showOtherAbilityFilter ||
      ls.get('showOtherAbilityFilter', { decrypt: true }) ||
      null
    );
  },

  showApproachFilter(state) {
    return (
      state.showApproachFilter ||
      ls.get('showApproachFilter', { decrypt: true }) ||
      null
    );
  },
  showEducationDegreeFilter(state) {
    return (
      state.showEducationDegreeFilter ||
      ls.get('showEducationDegreeFilter', { decrypt: true }) ||
      null
    );
  },

  showAgeRangeFilter(state) {
    return (
      state.showAgeRangeFilter ||
      ls.get('showAgeRangeFilter', { decrypt: true }) ||
      null
    );
  },
  showGenderFilter(state) {
    return (
      state.showGenderFilter ||
      ls.get('showGenderFilter', { decrypt: true }) ||
      null
    );
  },
  showTopicFilter(state) {
    return (
      state.showTopicFilter ||
      ls.get('showTopicFilter', { decrypt: true }) ||
      null
    );
  },
};
